import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';

const OFFER_HANDLE = 'untitled-may24_18-09-48';
let adjusting = false;

function offerLines(cart) {
  return (cart.items || []).filter((item) => item.handle === OFFER_HANDLE);
}

function offerQuantity(cart) {
  return offerLines(cart).reduce((sum, item) => sum + item.quantity, 0);
}

function sectionIds() {
  return Array.from(document.querySelectorAll('cart-items-component'))
    .map((item) => (item instanceof HTMLElement ? item.dataset.sectionId : ''))
    .filter(Boolean);
}

async function fetchCart() {
  return fetch('/cart.js').then((res) => res.json());
}

async function addMatchingItem(variantId) {
  const deferred = CartLinesUpdateEvent.createPromise();
  document.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'cart',
      lines: [{ merchandiseId: String(variantId), quantity: 1 }],
      promise: deferred.promise,
    })
  );

  const response = await fetch(Theme.routes.cart_add_url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      items: [{ id: Number(variantId), quantity: 1 }],
      sections: sectionIds().join(','),
    }),
  }).then((res) => res.json());

  if (response.status) {
    throw new Error(response.description || response.message || 'Could not add free item');
  }

  const cart = await fetchCart();
  deferred.resolve({
    cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
    detail: {
      items: cart.items,
      source: 'bundle-offer-auto',
      itemCount: cart.item_count,
      sections: response.sections,
      didError: false,
    },
  });
}

async function ensureOffer() {
  if (adjusting) return;

  const cart = await fetchCart();
  const quantity = offerQuantity(cart);
  if (quantity === 0 || quantity % 3 !== 2) return;

  const variantId = offerLines(cart)[0]?.variant_id;
  if (!variantId) return;

  adjusting = true;
  try {
    await addMatchingItem(variantId);
  } catch (error) {
    console.error(error);
  } finally {
    adjusting = false;
  }
}

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  if (adjusting) return;
  const promise = event.promise;
  if (promise?.then) {
    promise.then(() => ensureOffer()).catch(() => {});
    return;
  }
  ensureOffer();
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => ensureOffer(), { once: true });
} else {
  ensureOffer();
}
